import React from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ 
  content, 
  children, 
  position = 'top', 
  className = '' 
}) => {
  return (
    <div className={`group relative inline-block ${className}`}>
      {children}
      <div 
        className={`
          pointer-events-none absolute z-50 mb-2 w-max max-w-xs scale-95 rounded-md 
          bg-slate-900 px-3 py-2 text-xs sm:text-sm text-white opacity-0 transition-all 
          group-hover:scale-100 group-hover:opacity-100
          ${position === 'top' ? 'bottom-full left-1/2 -translate-x-1/2' : ''}
          ${position === 'bottom' ? 'top-full left-1/2 -translate-x-1/2 mt-2' : ''}
        `}
      >
        {content}
        <div 
          className={`
            absolute h-2 w-2 rotate-45 bg-slate-900
            ${position === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2' : ''}
            ${position === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2' : ''}
          `}
        />
      </div>
    </div>
  );
};
